import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { ProductCard } from "../ProductCard";
import { Reveal } from "../Reveal";
import { products } from "../../data/products";
export function SevenSinsSpotlight() {
  const rail = useRef<HTMLDivElement>(null);
  const railProducts = products.filter(p => p.collection === "seven-sins" || p.collection === "devils-candy");
  const scroll = (dir: number) => {
    const el = rail.current;
    if (!el) return;
    el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: "smooth"
    });
  };
  return <section className="bg-night py-20 lg:py-28" aria-labelledby="sins-title" data-id="element-305" data-mp="koxmzxyeflhl">
      <div className="mx-auto max-w-7xl px-6" data-id="element-306" data-mp="fqw53gcpls7p">
        <Reveal className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-307" data-mp="ft8uufopl6vb">
          <div className="lg:col-span-7" data-id="element-308" data-mp="trqg86r567a2">
            <h2 id="sins-title" className="font-display text-5xl font-extrabold tracking-tight sm:text-6xl" data-id="element-309" data-mp="tokrwtqc79fe">
              Seven Sins <span className="text-outline" data-id="element-310" data-mp="29rcppbptw8oi">&amp;</span> Devils Candy
            </h2>
            <p className="mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-311" data-mp="2dsg742niycru">
              Unlock the power of Seven Sins: a product line created to elevate your energy, explore your desires and
              amplify your confidence. Whether you need a boost for your day, a spark for the night, or just a little
              extra fun.
            </p>
          </div>
          <div className="flex items-center gap-3 lg:col-span-5 lg:justify-end" data-id="element-312" data-mp="2spgn58wcsjah">
            <Link to="/shop?collection=seven-sins" className="rounded-full bg-brand px-6 py-3.5 text-sm font-bold text-night transition-colors hover:bg-white" data-id="element-313" data-mp="2wpzg569zfve9">
              Shop Seven Sins
            </Link>
            <button type="button" onClick={() => scroll(-1)} className="flex h-12 w-12 items-center justify-center rounded-full border border-line transition-colors hover:border-white hover:bg-white hover:text-night" aria-label="Scroll products left" data-id="element-314" data-mp="3bg6sd49eci6i">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-315" data-mp="2lskqvcdsf61h" />
            </button>
            <button type="button" onClick={() => scroll(1)} className="flex h-12 w-12 items-center justify-center rounded-full border border-line transition-colors hover:border-white hover:bg-white hover:text-night" aria-label="Scroll products right" data-id="element-316" data-mp="30gytbm7akshi">
              <ArrowRightIcon className="h-5 w-5" data-id="element-317" data-mp="34j28olx30h82" />
            </button>
          </div>
        </Reveal>
      </div>

      <div ref={rail} className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto scroll-px-6 px-6 pb-4 lg:scroll-px-[max(1.5rem,calc((100vw_-_80rem)/2_+_1.5rem))] lg:px-[max(1.5rem,calc((100vw_-_80rem)/2_+_1.5rem))]" data-id="element-318" data-mp="3jerxertnj8gh">
        {railProducts.map((p, i) => <Reveal key={p.slug} delay={Math.min(i, 5) * 0.05} className="flex w-[70vw] shrink-0 snap-start sm:w-[300px]" data-id="element-319" data-mp="1k3qug1ktbsrx" data-mpi={i}>
            <div className="flex w-full flex-col" data-id="element-320" data-mp="3vqkjlft0ty9a">
              <ProductCard product={p} data-id="element-321" data-mp="4jhqgitmhhwf" />
            </div>
          </Reveal>)}
      </div>
    </section>;
}